<template>
  <div v-if="items.length" class="task-notification-host" aria-live="polite">
    <article v-for="item in items" :key="item.id" class="task-notification" :class="item.tone">
      <div class="notification-icon"><BellRing :size="17" /></div>
      <div class="notification-copy">
        <strong>{{ item.title }}</strong>
        <span v-if="item.orderNo">订单 {{ item.orderNo }}</span>
        <span v-if="item.shopName">{{ item.shopName }}</span>
        <span v-if="item.reason">{{ item.reason }}</span>
      </div>
      <button type="button" aria-label="关闭通知" @click="dismiss(item.id)"><X :size="15" /></button>
    </article>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { BellRing, X } from '@lucide/vue';
import { subscribeDesignerTaskNotifications } from '@/services/designerTaskRealtime';

const items = ref([]);
let unsubscribe = null;
const actionMeta = {
  ASSIGNED: { title: '你有新的设计任务', tone: 'success' },
  RETURNED_BY_FACTORY: { title: '工厂退回了设计任务', tone: 'danger' },
  RESUBMITTED: { title: '销售重新提交了设计任务', tone: 'warning' },
  TERMINATED: { title: '设计任务已终止', tone: 'muted' },
};

function dismiss(id) {
  items.value = items.value.filter(item => item.id !== id);
}

function receive(message) {
  const data = message?.data || {};
  const meta = actionMeta[data.action];
  if (!meta) return;
  const id = `${data.taskId}-${data.action}-${message.ts || Date.now()}`;
  items.value = [{ id, ...meta, ...data }, ...items.value].slice(0, 4);
  window.setTimeout(() => dismiss(id), 6000);
}

onMounted(() => { unsubscribe = subscribeDesignerTaskNotifications(receive); });
onUnmounted(() => unsubscribe?.());
</script>

<style scoped>
.task-notification-host { position: fixed; right: 22px; bottom: 22px; z-index: 1200; display: grid; gap: 10px; width: min(360px, calc(100vw - 32px)); }
.task-notification { display: grid; grid-template-columns: 36px 1fr auto; gap: 10px; padding: 14px; border: 1px solid var(--color-border); border-left: 4px solid var(--color-primary); border-radius: var(--radius-md); background: var(--color-bg-surface); box-shadow: var(--shadow-floating); }
.task-notification.danger { border-left-color: var(--color-accent-red); }.task-notification.warning { border-left-color: #f59e0b; }.task-notification.muted { border-left-color: var(--color-text-muted); }
.notification-icon { width: 34px; height: 34px; display: grid; place-items: center; border-radius: 50%; background: var(--color-primary-light); color: var(--color-primary); }
.notification-copy { display: flex; flex-direction: column; gap: 2px; min-width: 0; }.notification-copy strong { font-size: 14px; color: var(--color-text-main); }.notification-copy span { overflow: hidden; color: var(--color-text-muted); font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.task-notification button { align-self: start; color: var(--color-text-muted); }
</style>
